<main>
  <router-outlet></router-outlet>

  <div id="btn-register" class="fixed bottom-[80px] right-3 lg:bottom-[80px] z-[1000]">
    <button
      (click)="openRegisterFormPopup()"
      class="text-neutral-06 px-[6px] w-auto h-[48px] bg-primary rounded-full active:shadow-lg mouse shadow transition ease-in duration-200
        focus:outline-none group"
    >
      <span class="hidden group-hover:inline-block mr-1 animation-slip">{{ 'REGISTER_POPUP_BUTTON' | translate }}</span>
      <svg class="inline-block" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 12H24M11 16H22M8 8H27V27H14.5H8V8ZM11 20H19V23H11V20Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>

  <div id="btn-backtotop" class="fixed bottom-3 right-3 lg:bottom-[20px] z-[1000]">
    <button
      (click)="backToTop()"
      class="text-neutral-06 px-[6px] w-auto h-[48px] bg-secondary rounded-full active:shadow-lg mouse shadow transition ease-in
        duration-200 focus:outline-none group"
    >
      <svg width="36" height="36" viewBox="0 -3 18 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.18188 13.1613L9.22001 6.12316L16.2581 13.1613"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M9.29028 6.58064V24" stroke="white" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</main>
